export var MULTIPLAYER_TRACE_DOC_PREFIX = 'd0cd0c';
export var MULTIPLAYER_TRACE_DEBUG_PREFIX = 'debdeb';
export var MULTIPLAYER_TRACE_CONTINUOUS_DEBUG_PREFIX = 'cdbcdb';
export var MULTIPLAYER_TRACE_DEBUG_SESSION_SHORT_ID_LENGTH = 16;
export var MULTIPLAYER_OTEL_DEFAULT_TRACES_EXPORTER_URL = 'https://api.multiplayer.app/v1/traces';
export var MULTIPLAYER_OTEL_DEFAULT_LOGS_EXPORTER_URL = 'https://api.multiplayer.app/v1/logs';
export var MULTIPLAYER_ATTRIBUTE_PREFIX = 'multiplayer.';
export var ATTR_MULTIPLAYER_WORKSPACE_ID = 'multiplayer.workspace._id';
export var ATTR_MULTIPLAYER_PROJECT_ID = 'multiplayer.project._id';
export var ATTR_MULTIPLAYER_PLATFORM_ID = 'multiplayer.platform._id';
export var ATTR_MULTIPLAYER_CONTINUOUS_DEBUG_AUTO_SAVE = 'multiplayer.debugger.save';
export var ATTR_MULTIPLAYER_PLATFORM_NAME = 'multiplayer.platform.name';
export var ATTR_MULTIPLAYER_CLIENT_ID = 'multiplayer.client.id';
export var ATTR_MULTIPLAYER_INTEGRATION_ID = 'multiplayer.integration._id';
export var ATTR_MULTIPLAYER_DEBUG_SESSION_ID = 'multiplayer.debug_session._id';
/**
 * @deprecated
 */
export var ATTR_MULTIPLAYER_DEBUG_SESSION = 'multiplayer.debug_session._id';
export var ATTR_MULTIPLAYER_HTTP_REQUEST_BODY = 'multiplayer.http.request.body';
export var ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY = 'multiplayer.http.response.body';
export var ATTR_MULTIPLAYER_HTTP_REQUEST_HEADERS = 'multiplayer.http.request.headers';
export var ATTR_MULTIPLAYER_HTTP_RESPONSE_HEADERS = 'multiplayer.http.response.headers';
export var ATTR_MULTIPLAYER_HTTP_RESPONSE_BODY_ENCODING = 'multiplayer.http.response.body.encoding';
export var MASK_PLACEHOLDER = '***MASKED***';
export var MULTIPLAYER_DEBUG_REQUEST = 'multiplayer-debug-request';
//# sourceMappingURL=constants.base.js.map